import React, { useState, useEffect } from "react";
import styled from "styled-components";
import SourceImage from "Components/SourceImage";
import useWindowSize from "Hooks/useWindowSize";
import { BREAKPOINT_MOBILE, BREAKPOINT_TABLET } from "Styles/media";

const Wrapper = styled.div``;
const Sponsor = styled.ul`
	display: flex;
	flex-wrap: wrap;
`;

const Div = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 10px;
	height: 0.5px;
	background-color: ${(props) => props.theme.color.gray.light};
`;

const SponsorList = styled.li<{ col: number; isLast: boolean }>`
	width: ${(props) => `calc(100% / ${props.col})`};
	padding: 16px;
	position: relative;
	${Div} {
		display: ${(props) => props.isLast && "none"};
	}
`;
const Image = styled(SourceImage)`
	background-size: contain;
	background-repeat: no-repeat;
`;

const ListDiv = styled.div<{ active: boolean }>`
	position: absolute;
	bottom: 0;
	right: 0;
	opacity: ${(props) => (props.active ? 1 : 0)};
`;

const DivVer = styled(Div)`
	transform: translate(-50%, -50%) rotate(90deg);
`;
const DivHor = styled(Div)``;

const AboutSponsor: React.FC<{ data: string[] }> = ({ data }) => {
	const [col, setCol] = useState(6);
	const { size } = useWindowSize();
	useEffect(() => {
		if (size.width <= BREAKPOINT_MOBILE) {
			setCol(2);
		} else if (size.width <= BREAKPOINT_TABLET) {
			setCol(4);
		} else {
			setCol(4);
		}
	}, [size]);
	return (
		<Wrapper>
			<Sponsor>
				{data.map((el, index) => {
					return (
						<SponsorList key={index} col={col} isLast={(index + 1) % col === 0}>
							<ListDiv active={true}>
								<DivVer />
								<DivHor />
							</ListDiv>
							<Image image={el} />
						</SponsorList>
					);
				})}
			</Sponsor>
		</Wrapper>
	);
};

export default AboutSponsor;
